import { Box, Modal, useTheme,Button,Typography, IconButton} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import AuthGuard from "../../components/AuthGuard";
import { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import SmsFailedIcon from '@mui/icons-material/SmsFailed';
import SmsIcon from '@mui/icons-material/Sms';
import Tooltip from '@mui/material/Tooltip';
import swal from "sweetalert"


const Message = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [showModal,setShowModal] = useState(false)
  const [messagesData,setMessagesData] = useState([])
  const [cookies,setCookie] = useCookies(['token'])

  const fetchMessages = async()=>{
    try {
    const data = await fetch(process.env.REACT_APP_BACKEND_URL+"/message/all",{headers:{
      Authorization:"Bearer "+cookies['token'],
      'Content-Type':"application/json"
    }})
    if(data.status!==200){
      setCookie("token",null)
      return
    }
    const json = await data.json()
    setMessagesData(()=>{
      return json.map((msg,ind)=>({...msg,name:msg.receiver.full_name,no:ind+1}))
    })
  } catch (error) {
    console.error("Error fetching messages:", error);
  }
  };
  useEffect(()=>{
    fetchMessages();
  },[])

  const toggleEnableStatus = async (userId,currentStatus) => {
    const confirmed = window.confirm("Are you sure, you want to send this Message?");
    if (!confirmed) return;
  
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/message/${userId}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + cookies['token']
        },
      });
  
      const responseData = await response.json();
  
      if (response.ok) {
        swal("Success", responseData.message, "success");
        window.location.reload();
      } else {
        if (response.status === 401) {
          setCookie("token", null);
          swal("Failed", responseData.message, "error");
        } else if (response.status === 404) {
          swal("Failed", responseData.message, "error");
        } else {          
          throw new Error(responseData.message);
          swal("Failed", responseData.message, "error");
        }
      }
    } catch (error) {
      console.error('Error toggling user enable status:', error);
      swal("Failed", "Error toggling user enable status. Please try again", "error");
    }
  }
  const columns = [
    { field: "no", headerName: "No" },
      
    {
      field: "companies",
      headerName: "Company",
      flex: 1,
      renderCell: ({ row }) => {
        return (
          <Typography color={colors.black[500]} sx={{ ml: "5px" }}>
               {row.receiver?.companies?.name||"ZamZam Bank"}
          </Typography>
        );
      },
    },
    {
      field: "full_name",
      headerName: "Reciever",
      flex: 1,
      renderCell:({ row }) => {
        return (
          <Box>
              <Typography>{row.receiver?.full_name}</Typography>
          </Box>
        );
      },
    },
    {
      field: "phone",
      headerName: "Phone",
      flex: 1,
      renderCell: ({ row }) => {
        return (
          <Typography color={colors.black[500]} sx={{ ml: "5px" }}>
               {row.receiver?.phone}
          </Typography>
        );
      },
    },
    {
      field: "message_status",
      headerName: "Status",
      flex: 1,
      renderCell: ({ row }) => {
        const iconColor = row.message_status ? "green" : "red";
        const transactionType = row.message_status ? "Sent" : "Unsent";
        const icon = { transactionType, style: { color: iconColor } };
        return (
          <Typography color={colors.black[500]} sx={{ ml: "5px" }}>
            <span style={{ color: iconColor }}>{icon.transactionType}</span>
          </Typography>
        );
      }
    },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: ({ row }) => {
        const iconColor = row.message_status ? "green" : "red";
        const icon = row.message_status ? (
          <Tooltip title="Sent" arrow>
            <SmsIcon style={{ color: iconColor, fontSize: '30px'}} />
          </Tooltip>
        ) : (
          <Tooltip title="Resend" arrow>
            <SmsFailedIcon style={{ color: iconColor, fontSize: '30px' }} />
          </Tooltip>
        );
    
        return (
          <IconButton 
            onClick={() => toggleEnableStatus(row.id, row.message_status)}
            disabled={row.message_status} // Disable if message_status is true
          >
            <Typography color={colors.black[500]} sx={{ ml: "5px", mt:"10px"}}>
              {icon}
            </Typography>
          </IconButton>
        );
      },
    }
    
 
  ];

  const callBackAfterSubmit = ()=>{
    fetchMessages().then(()=>{
        setShowModal(false)
    })
  }

  return (
    <AuthGuard>
    <Box m="10px">
    <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
      <Header subtitle="View Messages" />
      </Box>
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          '& .MuiDataGrid-row:nth-child(odd)': {
            border: "1px solid white",
            backgroundColor: theme.palette.mode === 'light' ? colors.white[300] : "#F3F5F8",
          },
          '& .MuiDataGrid-iconSeparator': {
            display: 'none',
          },
          "& .MuiDataGrid-root": {
            border: "1px solid white",
          },
          "& .MuiDataGrid-row": {
            border: "1px solid white",

          },
          "& .MuiDataGrid-cell": {
            fontSize: 15,
            color: colors.black[500],
            border: "none !important",

          },
          "& .name-column--cell": {
            fontWeight: "bold",
            color: colors.black[500],
          },
          "& .MuiDataGrid-overlay, css-c1gd0l-MuiDataGrid-overlay": {
            backgroundImage: 'url(../../assets/zamzamlogoBlack.png)',
            mt:"70px", 
            backgroundSize: '80%',
            opacity: 0.2,
            backgroundRepeat: 'no-repeat',
            color:"none",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.white[500],
            color: colors.black[900],
            fontSize: 20,
            border: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            whiteSpace: "normal",
            lineHeight: "normal",
            fontWeight: "bold",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.white[500],
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor: colors.white[500],
            border: "none",

          },
          "& .MuiDataGrid-pagination": {
            "& .MuiTablePagination-menuItem": {
              color: "#000000",
            },
          },
          "& .MuiTablePagination-root": {
            color: "#000000",
          },
          "& .MuiSvgIcon-root ": {
            color: "#000000",
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            left: "75%",
            transform: `translateX(-75%)`,
            color: `${colors.black[500]} !important`,
          },
            "& .MuiDataGrid-row:hover": {
            backgroundColor: "none",
            },
        }}
      >
         {/* <Box> */}
        <DataGrid
          style={{position: "relative", height:"100%", with:"100%"}}
            rows={messagesData}
            columns={columns}
            backgroundColor={colors.zamzamBrandGreen[500]}
          />
      </Box>
      {/* </Box> */}
    </Box>
    </AuthGuard>
  );
};

export default Message;
